import React from "react";
import { makeStyles } from "@mui/styles";
import logo from '../assets/img/logo.png';
import { ChaoticOrbit } from "@uiball/loaders";

export const Loader = (props) => {

    const classes = useStyles();
    const { isLoading } = props;

    if(!isLoading) return;

    return (
        <div className={classes.mainLoader} >
            <img className={classes.fondo} src={ logo } alt="logo" />
            <ChaoticOrbit size={35} speed={1.5} color='#00365F' />
        </div>
    );
};

const useStyles = makeStyles({
    mainLoader: {
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        height: "100vh",
        background: "#fff",
        justifyContent: "center",
        alignItems: "center",
        overflow: 'hidden',
        position: 'absolute',
        zIndex: 9999999
    },
    fondo: {
        position: 'absolute',
        zIndex: 0,
        opacity: .02,
        width: '90vw',
        right: -500
    }
});